@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';

// For mobile
.dropdown-menu {
  font-size: 15px;
  > li > a {
    padding: 10px 20px;
    // Let text flow to multiple lines
    white-space: normal;
  }
}

// For larger screens
@media (min-width: @grid-float-breakpoint) {
  // Bigger dropdown links
  .dropdown-header {
    font-size: 14px;
    // @link https://getbootstrap.com/css/#less-mixins-truncating
    max-width: 170px;
    .text-overflow();
  }
  .dropdown-menu {
    font-size: 14px;
    > li > a {
      padding: 6px 20px;
      // Don't let text flow to multiple lines
      white-space: nowrap;
    }
  }
}

// Section full of small links inside dropdown menu
.dropdown-meta {
  padding: 0 10px;
  .active {
    font-weight: bold;
  }
}
